import { combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import gannWheel from "./gannWheel";
import loader from "./loader";
import login from "./login";
import plan from "./plan";

// Persist configuration
const persistConfig = {
  key: "login",
  storage,
};

const persistedReducer = persistReducer(persistConfig, login);

const rootReducer = {
  gannWheel,
  loader,
  login: persistedReducer,
  plan
};

export default rootReducer;
